import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["title", "disabled"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("button", {
    title: $props.label,
    class: _normalizeClass([$options.buttonClass, $options.fitInlineClass, $options.sizeClass, { 'btn-disabled': $props.isDisabled }, {'btn-block': $props.displayBlock}]),
    disabled: $props.isDisabled,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.handleClick && $options.handleClick(...args)))
  }, [
    (!!$props.icon && (!$props.iconAlignment || $props.iconAlignment === 'left'))
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createVNode(_component_font_awesome_icon, {
            class: _normalizeClass(["cta-icon-left", { 'cta-icon-no-padding': $props.noIconPadding }]),
            icon: $props.icon
          }, null, 8 /* PROPS */, ["icon", "class"])
        ]))
      : _createCommentVNode("v-if", true),
    ($props.label)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass([`cta-label`, {'cta-label-large': $props.largeLabelAtMobile }])
        }, [
          (!$props.useLabelAsTitleOnly)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString($props.label), 1 /* TEXT */)
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    (!!$props.icon && $props.iconAlignment === 'right')
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createVNode(_component_font_awesome_icon, {
            class: _normalizeClass(["cta-icon-right", { 'cta-icon-no-padding': $props.noIconPadding }]),
            icon: $props.icon
          }, null, 8 /* PROPS */, ["icon", "class"])
        ]))
      : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}